/* eslint-disable import/export */
import Menu from './Menu';
export * from './Menu';
export default Menu;